import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useReducer } from 'react';

import { toggleOverlayAppContent } from 'dpl/shared/utils';

import SummaryDetails from './SummaryDetails';

export default function SummaryDetailsSheet({ className, analytics }) {
  const [isExpanded, toggleIsExpanded] = useReducer(isOpen => !isOpen, false);

  useEffect(() => {
    toggleOverlayAppContent(isExpanded);

    return () => {
      toggleOverlayAppContent(false);
    };
  }, [isExpanded]);

  useEffect(() => {
    document.body.classList.add('has-summary-sheet');

    return () => {
      document.body.classList.remove('has-summary-sheet');
    };
  }, []);

  return (
    <>
      {isExpanded && (
        <button
          type="button"
          className="fixed top-0 right-0 bottom-0 left-0 bg-black o-50 z-999"
          onClick={toggleIsExpanded}
        />
      )}
      <div
        className={classnames(
          'SummaryDetailsSheet fixed right-0 bottom-0 left-0 z-999',
          !isExpanded && 'SummaryDetailsSheet--collapsed',
          className
        )}
      >
        <div className="relative">
          <button
            type="button"
            className="SummaryDetailsSheet__grabber z-1 pv3 tc w-100 absolute"
            onClick={toggleIsExpanded}
          >
            <span className="br1 dib" />
          </button>
          <SummaryDetails
            className="bg-white"
            ctaVariants={{ primary: 'bg-blue-500 white' }}
            analytics={analytics}
          />
        </div>
      </div>
    </>
  );
}

SummaryDetailsSheet.propTypes = {
  analytics: PropTypes.shape({
    view: PropTypes.string.isRequired,
    view_feature: PropTypes.string.isRequired,
    view_feature_location: PropTypes.string.isRequired
  }).isRequired,
  className: PropTypes.string
};

SummaryDetailsSheet.defaultProps = {
  className: null
};
